import React from 'react'
import { Box, Typography } from '@mui/material'
import { useTranslation } from 'react-i18next'
import { ListProperty } from 'types'

interface Props {
  list: ListProperty
}
function ListNameSM(props: Props) {
  const { list } = props
  const { t } = useTranslation()
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        maxWidth: '272px',
      }}
    >
      <Typography
        color="textPrimary"
        sx={{ fontWeight: 700, fontSize: '18px', textAlign: 'center' }}
      >
        {list.name}
      </Typography>
      <Typography
        color="textPrimary"
        sx={{ fontWeight: 400, fontSize: '14px', textAlign: 'center' }}
      >
        {t(`enums.listCategory.${list?.listCategory}`)}
        {list.userFavorites?.length
          ? ' (' +
            t(`generics.count`, {
              count: list.userFavorites?.length,
            }) +
            ')'
          : null}
      </Typography>
    </Box>
  )
}

export default ListNameSM
